import { useEffect, useState } from 'react';
import camilaImg from '../assets/camila.png';
import donaldImg from '../assets/donald.png';
import ericaImg from '../assets/erica.png';
import haileyImg from '../assets/hailey.png';
import jaylenImg from '../assets/jaylen.png';
import monicaImg from '../assets/monica.png';
import purpleBg from '../assets/purple_bg.webp';
import ratingStars from '../assets/rating_stars.svg';
import { getBrand } from '../utils/getBrand';

//TODO: update with custom data
const originalTestimonials = [
  {
    name: 'Erica T., 35',
    role: 'Accountant +20% salary growth',
    text: 'Honestly, it felt like having a personal recruiter. I went from zero responses to multiple interviews in just a few weeks and ended up with several offers. Wish I’d had this sooner!',
    verified: true,
    image: ericaImg,
  },
  {
    name: 'Hailey M., 32',
    role: 'Social media manager +26% salary growth',
    text: 'I always had a feeling, but I didn’t realize how underpaid I actually was. This helped me prove my value, ace interviews, and walk away with a much better deal. A total lifesaver.',
    verified: true,
    image: haileyImg,
  },
  {
    name: 'Jaylen R., 27',
    role: 'Software engineer +37% salary growth',
    text: 'This is nuts. I used to spend hours applying to like five jobs. Then suddenly, I was sending out hundreds automatically, getting interviews nonstop, and companies were literally competing for me. What??',
    verified: true,
    image: jaylenImg,
  },
  {
    name: 'Donald H., 47',
    role: 'Copywriter +35% salary growth',
    text: 'I got such a great offer and used it to negotiate a big raise at my current job. You guys made everything totally stress-free. 100% worth it.',
    verified: true,
    image: donaldImg,
  },
  {
    name: 'Camila H., 24',
    role: 'Data analyst +28% salary growth',
    text: 'I landed a new job in just a few weeks—and got a 28% raise! The interview prep and negotiation coaching made a huge difference. It felt like having insider knowledge.',
    verified: true,
    image: camilaImg,
  },
  {
    name: 'Monica J., 43',
    role: 'Account manager +20% salary growth',
    text: 'I felt stuck for years. My manager always liked me, but it never showed in my paycheck. Once I got an offer elsewhere, the vague promises stopped and they matched it right away. Thank you!',
    verified: true,
    image: monicaImg,
  },
];

const CARD_WIDTH = 350;
const CARD_MARGIN = 24;
const MOBILE_BREAKPOINT = 500;

function MobileCarousel({ testimonials }) {
  const [offset, setOffset] = useState(0);
  const [transition, setTransition] = useState('transform 0.3s linear');
  const [paused, setPaused] = useState(
    typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
  const totalSlides = testimonials.length;
  const slides = [...testimonials, ...testimonials];

  useEffect(() => {
    if (paused) return undefined;
    const interval = setInterval(() => {
      setOffset((prev) => prev + 1);
      setTransition('transform 0.3s linear');
      //TODO: cia jei noresi paletinti slideri ant mobile
    }, 8000);
    return () => clearInterval(interval);
  }, [paused]);

  useEffect(() => {
    if (offset >= totalSlides) {
      setTimeout(() => {
        setTransition('none');
        setOffset(0);
      }, 300);
    }
  }, [offset, totalSlides]);

  const vw = typeof window !== 'undefined' ? window.innerWidth : 375;
  const getTransform = () => {
    // Center the current card
    return `translateX(${(vw - CARD_WIDTH) / 2 - offset * (CARD_WIDTH + CARD_MARGIN)}px)`;
  };

  return (
    <div
      style={{
        overflow: 'hidden',
        width: '100vw',
        position: 'relative',
      }}
    >
      <button
        type="button"
        onClick={() => setPaused((p) => !p)}
        aria-label={paused ? 'Resume testimonials rotation' : 'Pause testimonials rotation'}
        className="absolute top-2 right-2 z-10 rounded-full bg-white/80 p-1.5 text-gray-600 shadow-sm hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black"
      >
        {paused ? (
          <svg width="10" height="10" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><path d="M2 1l9 5-9 5V1z" /></svg>
        ) : (
          <svg width="10" height="10" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><rect x="2" y="1" width="3" height="10" rx="1" /><rect x="7" y="1" width="3" height="10" rx="1" /></svg>
        )}
      </button>
      <div
        style={{
          display: 'flex',
          transition,
          transform: getTransform(),
          position: 'relative',
          left: '0',
        }}
      >
        {slides.map((testimonial, idx) => {
          const isCenter = idx === offset % totalSlides;
          return (
            <div
              key={idx}
              style={{
                width: CARD_WIDTH,
                marginRight: CARD_MARGIN,
                background: '#fff',
                borderRadius: 16,
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                padding: 24,
                flexShrink: 0,
                opacity: isCenter ? 1 : 0.4,
                transition: 'opacity 0.3s',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 12,
                }}
              >
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    marginRight: 16,
                  }}
                />
                <div>
                  <div style={{ fontWeight: 'bold' }}>{testimonial.name}</div>
                  <div style={{ fontSize: 11, color: '#666', paddingRight: '2px' }}>{testimonial.role}</div>
                </div>
                <img src={ratingStars} alt="Rating" style={{ height: 20, marginLeft: 'auto' }} />
              </div>
              <div style={{ color: '#333', marginBottom: 12 }}>{testimonial.text}</div>
              {testimonial.verified && (
                <div style={{ color: 'green', fontWeight: 500, fontSize: 14, marginTop: 'auto' }}>
                  &#10003; Verified User
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function DesktopCarousel({
  testimonials,
  modifiers = /** @type {{ shadowLeft?: string, shadowRight?: string }} */ ({}),
}) {
  const {
    shadowLeft = 'linear-gradient(to right, rgba(80, 40, 120, 0.35), transparent)',
    shadowRight = 'linear-gradient(to left, rgba(80, 40, 120, 0.35), transparent)',
  } = modifiers;

  const [offset, setOffset] = useState(Math.floor(testimonials.length / 2));
  const [transition, setTransition] = useState('transform 0.3s linear');
  const [paused, setPaused] = useState(
    typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
  const totalSlides = testimonials.length;
  const slides = [...testimonials, ...testimonials];
  const MIDDLE_INDEX = Math.floor(totalSlides / 2);

  useEffect(() => {
    if (paused) return undefined;
    const interval = setInterval(() => {
      setOffset((prev) => prev + 1);
      setTransition('transform 0.3s linear');
      //TODO: cia jei noresi paletinti slideri ant desktop
    }, 6000);
    return () => clearInterval(interval);
  }, [paused]);

  useEffect(() => {
    if (offset >= totalSlides + MIDDLE_INDEX) {
      setTimeout(() => {
        setTransition('none');
        setOffset(MIDDLE_INDEX);
      }, 300);
    }
  }, [offset, totalSlides, MIDDLE_INDEX]);

  // Center 3 full cards with partials on both sides, middle card in the center
  const getTransform = () => {
    return `translateX(calc(50vw - ${CARD_WIDTH / 2}px - ${offset * (CARD_WIDTH + CARD_MARGIN)}px))`;
  };

  return (
    <div
      style={{
        overflow: 'visible',
        width: '100vw',
        position: 'relative',
      }}
    >
      <button
        type="button"
        onClick={() => setPaused((p) => !p)}
        aria-label={paused ? 'Resume testimonials rotation' : 'Pause testimonials rotation'}
        className="absolute top-2 right-4 z-10 rounded-full bg-white/80 p-1.5 text-gray-600 shadow-sm hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black"
      >
        {paused ? (
          <svg width="10" height="10" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><path d="M2 1l9 5-9 5V1z" /></svg>
        ) : (
          <svg width="10" height="10" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><rect x="2" y="1" width="3" height="10" rx="1" /><rect x="7" y="1" width="3" height="10" rx="1" /></svg>
        )}
      </button>
      {/* Left shadow */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: 60,
          height: '100%',
          pointerEvents: 'none',
          zIndex: 2,
          background: shadowLeft,
        }}
      />
      {/* Right shadow */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: 60,
          height: '100%',
          pointerEvents: 'none',
          zIndex: 2,
          background: shadowRight,
        }}
      />
      <div
        style={{
          display: 'flex',
          transition,
          transform: getTransform(),
          position: 'relative',
          left: '0',
        }}
      >
        {slides.map((testimonial, idx) => (
          <div
            key={idx}
            style={{
              width: CARD_WIDTH,
              marginRight: CARD_MARGIN,
              background: '#fff',
              borderRadius: 16,
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              padding: 24,
              flexShrink: 0,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 12,
              }}
            >
              <img
                src={testimonial.image}
                alt={testimonial.name}
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: '50%',
                  marginRight: 16,
                }}
              />
              <div>
                <div style={{ fontWeight: 'bold' }}>{testimonial.name}</div>
                <div style={{ fontSize: 12, color: '#666' }}>{testimonial.role}</div>
              </div>
              <img src={ratingStars} alt="Rating" style={{ height: 20, marginLeft: 'auto' }} />
            </div>
            <div style={{ color: '#333', marginBottom: 12 }}>{testimonial.text}</div>
            {testimonial.verified && (
              <div style={{ color: 'green', fontWeight: 500, fontSize: 14, marginTop: 'auto' }}>
                &#10003; Verified User
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function TestimonialsSection({
  testimonials,
  onFirstButtonClick,
  onSecondButtonClick,
  showFirstButton,
  showSecondButton,
  firstButtonText,
  secondButtonText,
  modifiers = /** @type {{ sectionBg?: string, showImageBg?: boolean, shadowLeft?: string, shadowRight?: string, buttonBgColor?: string, buttonRadius?: string }} */ ({}),
}) {
  const {
    sectionBg = '',
    showImageBg = true,
    shadowLeft,
    shadowRight,
    buttonBgColor = 'bg-black',
    buttonRadius = 'rounded-full',
  } = modifiers;
  const { brandName } = getBrand();
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < MOBILE_BREAKPOINT : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section
      className={`relative py-16 overflow-hidden w-screen left-1/2 right-1/2 -mx-[50vw] md:py-[100px] ${sectionBg}`}
      id="testimonials"
    >
      {showImageBg && <img src={purpleBg} alt="" className="absolute inset-0 w-full h-full object-cover z-0" />}
      <div className="w-full relative z-10">
        <div className="flex flex-col sm:items-center items-start mb-6 px-4">
          <div className="flex sm:flex-row flex-col sm:items-center items-start gap-2">
            <div className="flex items-center gap-2">
              <img src={ratingStars} alt="Rating" className="h-6" />
              <span className="text-lg">
                Rated <span className="font-bold">4.8</span> / 5
              </span>
            </div>
          </div>
        </div>
        <h2 className="text-[32px] md:text-[48px] font-bold sm:text-center text-left px-4 mb-6">
          Real People. Real Results...
        </h2>
        <p className="font-inter font-normal text-[18px] leading-[26px] sm:text-center text-left px-4 mb-8">
          Find out what our customers had to say about {brandName}.
        </p>
        {isMobile ? (
          <MobileCarousel testimonials={testimonials ? testimonials : originalTestimonials} />
        ) : (
          <DesktopCarousel
            testimonials={testimonials ? testimonials : originalTestimonials}
            modifiers={{ shadowLeft, shadowRight }}
          />
        )}
        <div className="flex flex-col items-center mt-8 gap-6">
          <div className="flex justify-center px-4 w-full flex-col md:flex-row gap-4">
            {showFirstButton && (
              <button
                onClick={onFirstButtonClick}
                className={`${buttonBgColor} ${buttonRadius} text-white flex justify-center items-center gap-[10px] px-6 py-4 font-semibold transition-colors w-full sm:w-auto hover:bg-opacity-90`}
              >
                {firstButtonText}
              </button>
            )}
            {showSecondButton && (
              <button
                onClick={onSecondButtonClick}
                className={`${buttonRadius} flex justify-center bg-[#EBEBEB] text-black items-center gap-[10px] px-6 py-4 font-semibold transition-colors w-full sm:w-auto hover:bg-gray-200`}
              >
                {secondButtonText}
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
